import { makeUclComponent } from '@rbilabs/universal-components';

import Picture from 'components/picture';
import { withTypography } from 'components/ui';

export const Header = withTypography({
  fontFamily: 'heading',
  lineHeight: '2xs',
  textAlign: 'center',
  m: '$0',
  variant: 'headerOne',
  accessibilityLevel: 1,
  style: { width: 200, letterSpacing: 0.8 },
});

export const ItemText = withTypography({
  fontFamily: 'heading',
  lineHeight: '2xs',
  textAlign: 'center',
  m: '$0',
  variant: 'headerOne',
  accessibilityLevel: 1,
  style: { width: 200, letterSpacing: 0.8, textTransform: 'none' },
});

export const Body = withTypography({ textAlign: 'center', mx: '$0', my: '$2' });

export const StyledPicture = makeUclComponent(Picture).withConfig({
  height: '$40',
  width: '$40',

  marginX: {
    md: 0,
    base: 0,
  },

  marginY: {
    md: '$6',
    base: '$4',
  },
});
